import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de";
import en from "./en";
import nl from "./nl";

export const supported_language_list = ["nl", "en", "de"];

const resources = {
	de: {
		translation: de,
	},
	en: {
		translation: en,
	},
	nl: {
		translation: nl,
	},
};

i18n.use(initReactI18next).init({
	fallbackLng: "nl",
	interpolation: {
		escapeValue: false,
	},
	lng: "nl",
	resources: resources,
});

export default i18n;
